
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import store from '@/store';
import router from '@/router';

const ERROR_KEYS: Record<string, string> = {
  MISSING_FIELDS: 'authErrMissing',
  EMAIL_TAKEN: 'authErrEmailTaken',
  INVALID_CREDENTIALS: 'authErrInvalidCredentials',
  PASSWORD_MISMATCH: 'authErrPasswordMismatch',
  EMAIL_CONFIRMATION_REQUIRED: 'authInfoConfirmEmail',
};

@Options({
  computed: {
    ...mapGetters(['getJsonData', 'getAuthModalVisible', 'getAuthModalMode']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    }
  },
  data() {
    return {
      mode: 'register',
      submitting: false,
      error: '',
      registerForm: { fullName: '', email: '', phone: '', password: '', confirmPassword: '', agreeTerms: false },
      loginForm: { email: '', password: '' },
    };
  },
  watch: {
    getAuthModalVisible(visible: boolean) {
      if (visible) {
        (this as any).mode = (this as any).getAuthModalMode;
        (this as any).error = '';
      }
    }
  },
  methods: {
    close() {
      store.commit('SET_AUTH_MODAL', { visible: false });
    },
    async submitRegister() {
      const self = this as any;
      self.error = '';
      if (self.registerForm.password !== self.registerForm.confirmPassword) {
        self.error = self.jsonData[ERROR_KEYS.PASSWORD_MISMATCH];
        return;
      }
      self.submitting = true;
      try {
        await store.dispatch('registerUser', {
          fullName: self.registerForm.fullName,
          email: self.registerForm.email,
          password: self.registerForm.password,
          phone: self.registerForm.phone,
        });
        self.close();
        router.push('/');
      } catch (e: any) {
        const key = ERROR_KEYS[e.message] || 'authErrGeneric';
        self.error = self.jsonData[key];
      } finally {
        self.submitting = false;
      }
    },
    async submitLogin() {
      const self = this as any;
      self.error = '';
      self.submitting = true;
      try {
        await store.dispatch('loginUser', { email: self.loginForm.email, password: self.loginForm.password });
        self.close();
        router.push('/');
      } catch (e: any) {
        const key = ERROR_KEYS[e.message] || 'authErrGeneric';
        self.error = self.jsonData[key];
      } finally {
        self.submitting = false;
      }
    }
  }
})
export default class AuthModal extends Vue {}
